/*
 * ===============================================================================================================
 *                                Copyright 2022, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const KEY_NAMES = {
  NAME: 'name',
  ID: 'id',
  PREFERRED_MFA_EMAIL: 'email',
  PREFERRED_MFA_PHONE: 'phone'
};

export const LOCAL_IDP_TYPE = 'Local';
export const NATIVE_IDP_TYPE = 'Native';

export const PREFERRED_MFA_LIST = [
  { key: KEY_NAMES.PREFERRED_MFA_EMAIL, displayName: 'Email' },
  { key: KEY_NAMES.PREFERRED_MFA_PHONE, displayName: 'Mobile Phone' }
];

export const LABELS = {
  IDENTITY_PROVIDER: 'Identity Provider',
  ROLE_NAME_FROM_IDP: "Identity Provider Role Name",
  LOCAL_ROLE_NAME: "Blue Yonder Role Name",
  REQUIRED: 'Required',
  OPTIONAL: 'Optional'
};

export const MESSAGES = {
  USER_PASSWORD_TEXT: 'Here’s the temporary password for {0}',
  USER_PASSWORD_PARAGRAPH: 'Please ensure that you copy it now, as it will not be accessible again.',
  SHOW_USER_PASSWORD: 'Show User Password',
  HIDE_USER_PASSWORD: 'Hide User Password',
  COPY_TO_CLIPBOARD: 'Copy Password to Clipboard',
  PASSWORD_COPIED_TO_CLIPBOARD: 'Password Copied To Clipboard'
};

export const USER_FORM_FIELDS = {
  IDP_ID: 'idpId',
  USER_NAME: 'userName',
  DISPLAY_NAME: 'displayName',
  GIVEN_NAME: 'givenName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  MOBILE_PHONE: 'mobilePhone',
  IS_MFA_ENABLED: 'isMfaEnabled',
  PREFERRED_MFA: 'preferredMfa',
  LOCAL_ROLE_NAME: "LOCAL_ROLE_NAME",
  ROLE_ID: 'byRoleId',
  PASSWORD: 'password',
  PRE_REGISTRATION: 'preRegistration',
  LOCATION_ID: 'locationId'
};

export const FEDERATED_USER_FIELDS = [
  USER_FORM_FIELDS.IDP_ID,
  USER_FORM_FIELDS.USER_NAME,
  USER_FORM_FIELDS.DISPLAY_NAME,
  USER_FORM_FIELDS.GIVEN_NAME,
  USER_FORM_FIELDS.LAST_NAME,
  USER_FORM_FIELDS.EMAIL
];

export const LOCAL_USER_FIELDS = [
  USER_FORM_FIELDS.IDP_ID,
  USER_FORM_FIELDS.USER_NAME,
  USER_FORM_FIELDS.DISPLAY_NAME,
  USER_FORM_FIELDS.GIVEN_NAME,
  USER_FORM_FIELDS.LAST_NAME,
  USER_FORM_FIELDS.EMAIL,
  USER_FORM_FIELDS.MOBILE_PHONE,
  USER_FORM_FIELDS.IS_MFA_ENABLED,
  USER_FORM_FIELDS.PREFERRED_MFA
];

export const NATIVE_USER_EDIT_FIELDS = [
  USER_FORM_FIELDS.IDP_ID,
  USER_FORM_FIELDS.USER_NAME,
  USER_FORM_FIELDS.DISPLAY_NAME,
  USER_FORM_FIELDS.GIVEN_NAME,
  USER_FORM_FIELDS.LAST_NAME,
  USER_FORM_FIELDS.EMAIL
];

export const NATIVE_USER_FIELDS = [
  ...NATIVE_USER_EDIT_FIELDS,
  USER_FORM_FIELDS.PASSWORD,
  USER_FORM_FIELDS.PRE_REGISTRATION
];

export const SNACKBAR_ALERT_DEFAULT_PROPS = {
  showSnackbar: true,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as 'success' | 'error'
};
